export default __webpack_public_path__ + "static/media/rooms.571a1c57.png";